<template>
  <div>
    <div class="ui bottom attached segment pushable" ref="context">
      <div class="ui right sidebar" style="" ref="sidebar">
        <div class="ui form" style="padding: 10px 15px;">
          <div class="field">
            <label for="">{{ $t("name") }}</label>
            <input type="text" name="name" v-model="task_info.name" />
          </div>
          <div class="field">
            <label for="">{{ $t("duration") }} ({{ $t("days") }})</label>
            <input type="text" name="duration" v-model="task_info.duration" />
          </div>
          <div class="field">
            <label for="">{{ $t("start date") }}</label>
            <input
              type="text"
              name="start_date"
              v-model="task_info.start_date"
            />
          </div>
          <div class="ui grid">
            <div class="eight wide column">
              <div
                class="ui fluid mini green icon labeled button"
                @click="apply"
              >
                <i class="check icon"></i>
                {{ $t("apply") }}
              </div>
            </div>
            <div class="eight wide column">
              <div
                class="ui fluid mini red icon labeled button"
                @click="remove"
              >
                <i class="trash icon"></i>
                {{ $t("delete") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="pusher"
        style="width: 100% !important; height: 100% !important"
      >
        <svg
          ref="svg"
          style="width: 100% !important; height: 100% !important"
        ></svg>
      </div>
    </div>
    <!-- <svg
      ref="svg"
      style="width: 100% !important; height: 100% !important"
    ></svg> -->
    <!-- <div v-html="chart_html"></div> -->
    <!-- <canvas style="width: 100% !important" ref="canvas"></canvas> -->
    <!-- <svg id="gantt"></svg> -->
  </div>
</template>

<script>
// import { local_api, error_toast } from "@/utils";
import { SVGGantt /* CanvasGantt */ /* , StrGantt */ } from "gantt";
// import "frappe-gantt/dist/frappe-gantt.js";
// import "frappe-gantt/dist/frappe-gantt.css";
// import moment from "moment";

export default {
  name: "ProjectPlanModalGantt",
  data() {
    return {
      gantt: undefined,
      chart_html: "",
      task_info: {
        name: "",
        duration: "",
        start_date: "",
      },
    };
  },
  components: {},
  mounted() {
    let vm = this;
    // console.log("gantt", gantt);
    const data = [
      {
        id: 1,
        type: "group",
        text: "1 Waterfall model",
        start: new Date("2022-10-10T09:24:24.319Z"),
        end: new Date("2022-12-12T09:32:51.245Z"),
        percent: 0.8,
        // links: [],
      },
      {
        id: 11,
        // parent: 1,
        text: "1.1 Requirements",
        start: new Date("2022-10-21T09:24:24.319Z"),
        end: new Date("2022-11-22T01:01:08.938Z"),
        percent: 0.29,
        links: [
          {
            target: 12,
            // type: "FS",
            type: "FS",
            // type: "FS",
            // type: "FS",
          },
        ],
      },
      {
        id: 12,
        // parent: 1,
        text: "1.2 Design",
        start: new Date("2022-11-05T09:24:24.319Z"),
        end: new Date("2022-12-12T09:32:51.245Z"),
        percent: 0.78,
      },
    ];

    new SVGGantt(vm.$refs.svg, data, {
      viewMode: "week",
      onClick: function(item) {
        console.log("item", item);
        window
          .jQuery(vm.$refs.sidebar)
          .sidebar({
            context: vm.$refs.context,
            onVisible() {
              vm.task_info.name = item.text;
              vm.task_info.start_date = item.start;
            },
          })
          // .sidebar("setting", "transition", "overlay")
          .sidebar("toggle");
      },
    });

    // new CanvasGantt(vm.$refs.canvas, data, {
    //   viewMode: "week",
    //   onClick: function(item) {
    //     console.log("item", item);
    //   },
    // });

    // const strGantt = new StrGantt(data, {
    //   viewMode: "week",
    //   onClick: function(item) {
    //     console.log("item", item);
    //   },
    // });

    // let xx = strGantt.render();
    // vm.chart_html = xx;

    // console.log("XX", xx);
    // console.log("strGantt", strGantt);
  },
  beforeUnmount() {},
  methods: {
    // checkGantt() {
    //   let vm = this;
    //   if (typeof window.Gantt == "undefined") {
    //     console.log("Gantt is undefined");
    //     setTimeout(() => {
    //       vm.checkGantt();
    //     }, 1000);
    //   } else {
    //     // eslint-disable-next-line no-undef
    //     vm.setGantt();
    //   }
    // },
    // setGantt() {
    //   let vm = this;

    //   var tasks = [
    //     {
    //       id: "Task 1",
    //       name: "Redesign website",
    //       start: "2022-03-28",
    //       end: "2022-06-31",
    //       progress: 20,
    //       dependencies: "Task 2, Task 3",
    //     },
    //   ];
    //   // eslint-disable-next-line no-undef
    //   vm.gantt = new window.Gantt("#gantt", tasks, {
    //     on_click: function(task) {
    //       console.log(task);
    //     },
    //     on_date_change: function(task, start, end) {
    //       console.log(task, start, end);
    //     },
    //     on_progress_change: function(task, progress) {
    //       console.log(task, progress);
    //     },
    //     on_view_change: function(mode) {
    //       console.log(mode);
    //     },
    //     //     custom_popup_html: function(task) {
    //     //       console.log("task", task);
    //     //       // the task object will contain the updated
    //     //       // dates and progress value
    //     //       const end_date = 'task._end.format("MMM D")';
    //     //       return `
    //     // <div class="details-container">
    //     //   <h5>${task.name}</h5>
    //     //   <p>Expected to finish by ${end_date}</p>
    //     //   <p>${task.progress}% completed!</p>
    //     // </div>
    //     // `;
    //     //     },
    //     // header_height: 50,
    //     // column_width: 30,
    //     // step: 24,
    //     // view_modes: ["Quarter Day", "Half Day", "Day", "Week", "Month"],
    //     bar_height: 20,
    //     bar_corner_radius: 3,
    //     arrow_curve: 5,
    //     padding: 18,
    //     view_mode: "Month",
    //     date_format: "YYYY-MM-DD",
    //     // custom_popup_html: null,
    //   });
    // },
    apply() {
      console.log("apply changes");
    },
    remove() {
      console.log("remove task");
    },
  },
};
</script>
